import React, { Component } from 'react'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'

class WelcomeDeclined extends Component {
  constructor(props) {
    super(props)
    this.props.updateActivePage(null)
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus()
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div id="welcome_declined">
        <AriaMessage message="Navigated to declined page" />
        <Title>Welcome to Newtopia</Title> 
        <div className="container">
          <h2>Not quite ready? That's okay!</h2>
          <h3 className="welcomeHeaders">If this isn't the right time, you can choose to start the Newtopia program whenever you're ready. A member of the Client Care team will be in touch with you shortly.</h3>
        </div>
      </div>
    )
  }
}

export default WelcomeDeclined